import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class AnnouncementGotItClicked extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ANNOUNCEMENT_GOT_IT_CLICKED;

  announcementId: number;

  constructor(announcementId: number) {
    super();

    this.announcementId = announcementId;
  }
}
